import { createEvent, sample } from 'effector'
import { BanRequest, BanRequestData } from './types'
import { fx } from '../../../../../libs'

export const banMounted = createEvent<BanRequestData>()

export const banClient = fx<BanRequest, void>({
  method: 'PUT',
  url: `/promo/golden_may/participant/{clientId}`,
})

sample({
  clock: banMounted,
  fn: ({ banReason, id }) => {
    return {
      url: `/promo/golden_may/participant/${id}`,
      body: {
        banReason: banReason,
      },
    }
  },
  target: banClient,
})
